























import ApiClient from '@/js/api.js'
import Global from '@/js/global.js'
import YellowButton from '@/views/atoms/YellowButton.vue'

export default
  components: {
    YellowButton
  }

  props:
    status:
      type: Number
      default: 0

  data: () ->
    orders: []

  created: () ->
    param =
      page: ''
      from: ''
      to: ''
      status: @status
      order_code: ''
    api = new ApiClient()
    data = await api.post('/member/purchase_history/list', true, param)
    @orders = data.list
  methods: {
    go_detail: (id) ->
      @$router.push '/mypage/order/detail?id=' + id
    pay_name: (id) ->
      for key, row of Global.getPayStyles()
        if key == id
          return row
      return ''
    tax: (price) ->
      Global.tax(price)
    comma: (price) ->
      Global.comma(price)
  }
